import template from "./bypass_code.html";
import controller from "./bypass_code.controller";
import "./bypass_code.scss"
let branchManagementBypassCodeComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchManagementBypassCodeComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/bypass_code/bypass_code.component.js